module.exports = __webpack_public_path__ + "static/smarts-455041b8d2e002f77c7eaef3f5da39f3.png";